export const SEARCH_INTERNAL_PRODUCTS = 'SEARCH_INTERNAL_PRODUCTS';
export type SEARCH_INTERNAL_PRODUCTS = typeof SEARCH_INTERNAL_PRODUCTS;

export interface SearchInternalProducts {
    type: SEARCH_INTERNAL_PRODUCTS;
    text: string;
}

export function searchInternalProductsAction(text: string): SearchInternalProducts {
    return {
        type: SEARCH_INTERNAL_PRODUCTS,
        text
    };
}
